import { FC } from 'react';

import { useExperiments } from 'state/experiments';

import { ExperimentVariants, IExperimentProps } from './types';

export const Experiment: FC<IExperimentProps> = ({ flag, treatment, control, fallback }) => {
  const { getVariantValue, logExposure } = useExperiments();
  const value = getVariantValue(flag)?.value;
  if (value === ExperimentVariants.Control) {
    logExposure(flag);
    return control ?? null;
  } else if (value === ExperimentVariants.Treatment) {
    logExposure(flag);
    return treatment ?? null;
  }
  // If fallback is undefined returns control
  return fallback !== undefined ? fallback : control ?? null;
};
